import Agra from '../Images/destination/agra-india.png'
import Bangkok from '../../src/Images/destination/bangkok-thailand.png'
import Bernese from '../../src/Images/destination/bernese-oberland-switzerland.png'
import Dubai from '../../src/Images/destination/dubai-UAE.png'
import Elsene from '../../src/Images/destination/elsene-belgium.png'
import Florence from '../../src/Images/destination/florence-italy.png'
import Glenfinnan from '../../src/Images/destination/glenfinnan-united-kingdom.png'
import Kandy from '../../src/Images/destination/kandy-sri-lanka.png'
import Kashmir from '../../src/Images/destination/Kashmir-india.png'
import Liguria from '../../src/Images/destination/liguria-italy.png'
import Mumbai from '../../src/Images/destination/mumbai-india.png'
import Prague from '../../src/Images/destination/prague-czech-republic.png'
import Rome from '../../src/Images/destination/rome-italy.png'
import Saitama from '../../src/Images/destination/saitama-japan.png'
import Beijing from '../../src/Images/destination/beijing-china.png'

const destinations = [
    {
        id: 1,
        image: Agra,
        city: 'Agra, India',
        rating: '4.8',
        reviews: '1.5k Review'
    },
    {
        id: 2,
        image: Bangkok,
        city: 'Bangkok, Thailand',
        rating: '3.7',
        reviews: '4.6k Review'
    },
    {
        id: 3,
        image: Bernese,
        city: 'Bernese Oberland, Switzerland',
        rating: '4.6',
        reviews: '8k Review'
    },
    {
        id: 4,
        image: Dubai,
        city: 'Dubai, United Arab Emirate',
        rating: '5.0',
        reviews: '20k Review'
    },
    {
        id: 5,
        image: Elsene,
        city: 'Elsene Belgium',
        rating: '3.8',
        reviews: '1k Review'
    },
    {
        id: 6,
        image: Florence,
        city: 'Florance Italy',
        rating: '4.7',
        reviews: '5.6k Review'
    },
    {
        id: 7,
        image: Glenfinnan,
        city: 'Glenfinnan, United Kingdom',
        rating: '4.0',
        reviews: '4.3k Review'
    },
    {
        id: 8,
        image: Kandy,
        city: 'Kandy, Sri Lanka',
        rating: '3.4',
        reviews: '2.4k Review'
    },
    {
        id: 9,
        image: Kashmir,
        city: 'Kashmir, India',
        rating: '3.2',
        reviews: '1.4k Review'
    },
    {
        id: 10,
        image: Liguria,
        city: 'Liguria, Italy',
        rating: '3.6',
        reviews: '5k Review'
    },
    {
        id: 11,
        image: Mumbai,
        city: 'Mumbai India',
        rating: '4.9',
        reviews: '8k Review'
    },
    {
        id: 12,
        image: Prague,
        city: 'Prague, Czech Republic',
        rating: '4.4',
        reviews: '3k Review'
    },
    {
        id: 13,
        image: Rome,
        city: 'Rome, Italy',
        rating: '4.8',
        reviews: '9k Review'
    },
    {
        id: 14,
        image: Saitama,
        city: 'Saitama, Japan',
        rating: '3.8',
        reviews: '3k Review'
    },
    {
        id: 15,
        image: Beijing,
        city: 'Beijing, China',
        rating: '3.5',
        reviews: '7k Review'
    },
]

export default destinations